module.exports = __webpack_public_path__ + "img/lejiandai-logo.fbfa455b.png";